import { useCallback, useReducer } from 'react';
import { FormOneReducer } from './FormOneReducer';
import { FormOneContext } from './FormOneContext';
import { UPDATE_FORM_ONE } from './types';


export const FormOneState = (props) => {

    const initialState = {
        formOne: {
            firstname: "",
            secondname: "",
            firstlastname: "",
            secondlastname: "",
            maritalStatus: "",
            age: "",
            gender: "",
            educationLevel: "",
            depAddress: "",
            cityAddress: ""
        }
    }

    const [state, dispatch] = useReducer(FormOneReducer, initialState);

    const updateFormOne = useCallback((data) => {
        dispatch({
            type: UPDATE_FORM_ONE,
            payload: data
        })
    }, [])

    return (
        <FormOneContext.Provider value={{ formOne: state.formOne, updateFormOne }}>
            {props.children}
        </FormOneContext.Provider>
    )

}


